module.exports = __webpack_public_path__ + "static/media/move-to-earn.ccd4df88.png";